import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr 1fr;
  grid-column-gap: 0.5rem;
  align-items: center;
`;
